// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Wztz","title":"Info_title__1aD7h","links":"Info_links__1IybU","link":"Info_link__1VLUh","logo":"Info_logo__1dlrW"};